import React from "react";
import ProjectsPage from "@/pages/ProjectsPage";

/** /arbeid – the work surface on every screen size (rows become cards below 768px). */
export default function WorkPage() {
  return <ProjectsPage />;
}
